import Vue from 'vue'

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
import VueGoodTable from 'vue-good-table'

// Form validations, popups, ux elements
import VeeValidate from 'vee-validate'
import Sweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import StretchLoader from 'vue-loading-spinner/src/components/Stretch'

import { clearSession } from '@/lib/auth'

// Charts
import { loadHighcharts } from '@/lib/highcharts'

// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'

export const loadComponents = () => {
  loadHighcharts()

  // load modules to vue
  Vue.use(BootstrapVue)
  Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
  Vue.use(VueGoodTable)

  Vue.use(VueGoogleMaps, {
    load: {
      key:  'AIzaSyA1FjcYxum9m27E3OXoOLUPmdbxPVP3o4k',
      libraries: 'places'
    }
  })

  Vue.use(Sweetalert2, {
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true
  })
  
  // global components
  Vue.component('StretchLoader', StretchLoader)

  // global mixins
  Vue.mixin({
    methods: {
      getPriorityText: (priority) => {
        let priorities = { 1: 'High', 2: 'Medium', 3: 'Low' }
        return `${priority} - ${priorities[priority]}`
      },
      resetSession: (apolloClient) => {
        apolloClient.clearStore()
        clearSession()
      }
    }
  })

}
